import login_api from './login.png'
import device_create from './create-device.png'
import { Link } from 'react-router-dom';
const DeviceInterface = () => {
    return (
        <section>
        <div className="bg-black bg-opacity-60 fixed z-50 left-0 top-0 w-[100%] h-[100%] overflow-hidden flex items-center justify-center">
        <div className="flex flex-row w-[80%] gap-2 px-8 pt-4 pb-6 bg-white rounded-md relative">
            <div className='absolute'>
            <Link to="/device-management" onClick={''} className='px-4 py-1 text-white border rounded-md bg-vekin'> {"<"} Back</Link>    
            </div>
            <div className='mt-8 shadow'>
                <img src={device_create} alt="create device interface" />
            </div>
            <div className='mt-8 shadow'>
                <img src={login_api} alt="login interface" />
            </div>

            </div> 
        </div>

        </section>
     );
}
 
export default DeviceInterface;